import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { addPageFolderChildrenCount } from '../../visual/visual.actions';

@Component({
  selector: 'nns-show-more',
  template: `
    <div class="nns-show-more-button nns-noselect nns-animated"
      (click)="showMore()"
    >
      SHOW MORE
    </div>
  `,
  styles: [`
    :host {
      display:block;
      padding:16px 10px 0 10px;
    }
    .nns-show-more-button {
      display:block;
      width:100%;
      padding:16px 0;
      cursor:pointer;
      color:#0096a7;
      font-size:12px;
      text-align:center;
      border:1px solid #cdcdcd;
      font-weight:bold;
      border-radius:2px;
    }
    .nns-show-more-button:hover {
      opacity:0.7;
    }
  `, `
    :host-context(.nns-theme-night) .nns-show-more-button  {
      color:#fff;
      background-color: #292E32;
      border-color:rgba(0,0,0, 0.12);
    }
    :host-context(.nns-theme-night) .nns-show-more-button:hover {
      background: rgba(181,181,181,0.10);
      opacity:1;
    }
  `]
})
export class ShowMoreComponent {
  constructor(
    public _store: Store<IAppState>
  ) { }

  showMore() {
    this._store.dispatch(addPageFolderChildrenCount());
  }
}
